import { getTypeTree } from 'api/module/materialsBill'

const common = {
    namespaced: true,
    state: {
        interfaceLoading: false, // 公共接口loading
        clientHeight: document.documentElement.clientHeight, // 屏幕高度
        materialTreeData: [], // 材料树
        cancelAxios: function () { },
        openChangePswdWindow: false,
        isCity: false, //是不是地级市用户
    },
    mutations: {
        updateInterfaceLoading(state, data) {
            state.interfaceLoading = data
        },

        updateMaterialTreeData(state, data) {
            state.materialTreeData = data
        },

        updateCancelAxios(state, data) {
            state.cancelAxios = data
        },

        updateOpenChangePswdWindow(state, data) {
            state.openChangePswdWindow = data
        },

        updateCityState(state, data) {
            state.isCity = data
        }
    },
    actions: {
        // 材料树接口
        getMaterialTree(context) {
            getTypeTree().then(res => {
                // console.log(res)
                res.data.tree.unshift({
                    id: '',
                    sname: '全部',
                    value: ''
                })
                context.commit('updateMaterialTreeData', res.data.tree)
            })
        }
    }
}

export default common



// WEBPACK FOOTER //
// ./src/store/modules/common.js